import { all, put, select } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';
import { selectors, withOffset } from '../../Stream';
import {
  DEVIATIONS_PER_FETCH,
  MEDIA_POPUP_CUSTOM_DEVIATION_SET_STREAM_ID,
} from '../constants';
import { initCustomSetDeviationStream } from '../actions';
import { normalizeDeviations } from '../../redux/normalizr/helpers';

function* handleInitCustomSetDeviationStream(
  action: ReturnType<typeof initCustomSetDeviationStream>
): SagaIterator {
  const deviations = action.payload;
  const streamId = MEDIA_POPUP_CUSTOM_DEVIATION_SET_STREAM_ID;

  const { result: ids, entities } = normalizeDeviations(deviations);

  const isStreamInitialized: ReturnType<typeof selectors.isInitialized> =
    yield select(selectors.isInitialized, streamId);
  if (isStreamInitialized) {
    return;
  }

  yield all([
    put(
      withOffset.actions.initialize({
        streamId,
        itemsPerFetch: DEVIATIONS_PER_FETCH,
        items: ids,
        entities,
      })
    ),
    put(withOffset.actions.fetch(streamId)),
  ]);
}

export default handleInitCustomSetDeviationStream;
